// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HintTrigger-base__tgdac{color:var(--gray-a8);cursor:help;transition-delay:var(--duration-fast);transition-property:color}@media (hover: hover){.HintTrigger-base__tgdac:hover{color:var(--gray-a12)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "HintTrigger-base__tgdac"
};
export default ___CSS_LOADER_EXPORT___;
